import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  customFinePrint?: ReactNode
}

export const UserFinePrint = ({ customFinePrint }: Props) => {
  return (
    <p className="px-12 py-10 text-center my-body-sm ">
      {customFinePrint ?? (
        <FormattedMessage
          defaultMessage="If you have questions about your order, please reach out to the venue."
          id="fN2HY3"
        />
      )}
    </p>
  )
}
